import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signIn } from '../../api';
import type { SignInParams } from '../../types';
import { identifyDataLayerUser } from '@/shared/analytics';

export function useSignIn() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: SignInParams) => signIn(params),
    onSuccess: (user) => {
      identifyDataLayerUser(user.id);
      return queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
